import React from "react";
import Warning from "../../components/Warning";
import DeletePlantContainer from "../../containers/plants/DeletePlantContainer";

const DeletePlant = ({ plant, handleClose = () => {}, open }) => {
  return (
    <DeletePlantContainer plant={plant} handleClose={handleClose}>
      {({ onSubmit }) => (
        <Warning
          openWarning={open}
          message={`Confirm the action? All of the following related ekloks will be deleted: ${plant.ekloks.map((eklok) => eklok.name)}`}
          onCloseConfirm={onSubmit}
          onCloseCancel={handleClose}
        />
      )}
    </DeletePlantContainer>
  );
};

export default DeletePlant;
